<template>
  <div class="search-box">
    <el-form ref="form" :inline="true" size="mini"  :model="ruleForm" :rules="rules" class="demo-form-inline">
      <el-form-item label="日志时间:" prop="date">
        <date-time-range @changeDateTime="changeDateTime"/>
      </el-form-item>
      <el-form-item label="操作地区：">
        <!-- <muti-dep-code-tree v-model="ruleForm.depCodeArry" mood="nostrict"/> -->
        <dep-code-tree v-model="ruleForm.depCodeArry"></dep-code-tree>
      </el-form-item>
      <!--<el-form-item label="操作系统：" prop="operateId ">-->
        <!--<el-select v-model="ruleForm.operateId " placeholder="请选择" style="max-width:180px;" filterable clearable>-->
          <!--<el-option-->
            <!--v-for="item in systemList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
          <!--&gt;</el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item label="用户名称：" prop="userName">
        <el-input v-model="ruleForm.userName" style="max-width:180px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="submit">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import dateTimeRange from '../comm/dateTimeRange';
import DepCodeTree from '@/views/comm/depCodeTree';
// import MutiDepCodeTree from '@/views/comm/mutiDepCodeTree';

export default {
  name: 'search',
  components: {
    dateTimeRange,
    DepCodeTree
    // MutiDepCodeTree
  },
  props: {
    systemList: {
      type: Array
    }
  },
  data() {
    return {
      ruleForm: {
        operateId: '',
        depCodeArry: [],
        depCode: '',
        startDate: '',
        endDate: '',
        userName: ''
      },
      rules: {}
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor'
    })
  },
  methods: {
    changeDateTime(date) {
      Object.assign(this.ruleForm, this.ruleForm, date);
    },
    handleChange(arry) {
      if (arry.length > 0) {
        this.ruleForm.depCode = arry[arry.length - 1];
      }
      else {
        this.ruleForm.depCode = '';
      }
    },
    // handelForm(data) {
    //   return {
    //     depCode: data.depCode.map(item => item.value).join(','),
    //     startDate: '',
    //     endDate: ''
    //   };
    // },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          // this.ruleForm.depCode = this.ruleForm.depCodeArry.map(item => item.value).join(',');
          this.ruleForm.depCode = this.$utils.deepCopy(this.ruleForm.depCodeArry).pop();
          this.$emit('getOperateLogDepartHistogram', this.ruleForm);// emit
        }
        else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.ruleForm.depCodeArry = [this.userInfor.depCode];
    this.submit();
  }
};
</script>
<style lang="scss" scoped>
</style>
